import React, { useCallback, useEffect, useState } from 'react';
import { delay } from 'utils';
// Context
import { useAppDispatch } from 'context/AppContext';
import { removeNotification } from 'context/AppContext/actions';
// Assets
import Icon from 'assets/Icon';
// Style
import styles from './style/notification.module.css';

interface NotificationProps {
  id: string,
  label: string,
  type: string,
}

function setIcon(type:string) {
  if (type === 'error') {
    return (
      <Icon icon="Error" fill="strawberry" />
    );
  }
  if (type === 'warning') {
    return (
      <Icon icon="Warning" fill="fresh-yellow-700" />
    );
  }
  if (type === 'success') {
    return (
      <Icon icon="Tick" fill="fresh-green" />
    );
  }
  return (
    <Icon icon="Info" fill="blueberry" />
  );
}

function Notification({ id, label, type }: NotificationProps) {
  const dispatch = useAppDispatch();
  const [active, setActive] = useState(false);
  const removeAfterDelay = useCallback(async () => {
    await delay(3000);
    dispatch(removeNotification(id));
  }, [dispatch, id]);

  useEffect(() => {
    setActive(true);
    removeAfterDelay();
  }, [removeAfterDelay]);

  return (
    <div className={`${styles.container} ${active ? styles.container_active : ''} subtitle1`}>
      <div className={styles.icon}>
        { setIcon(type) }
      </div>
      { label }
    </div>
  );
}

export default Notification;